import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// tailwind-merge must know about our `tw` prefix, otherwise it treats
// `tw:p-2` and `tw:p-4` as unrelated classes and keeps both.
const twMerge = extendTailwindMerge({ prefix: 'tw' });

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
